import React, { Component } from "react";
import { MnemoLoading, Title, BoxInfo } from "components/misc";
import { dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container, Row, Col } from "design-react-kit";
import { LESSON_ACTIVITY_TYPES, ROUTES } from "const";
import { revisionService } from "libs/api/revisionService";
import { getCurrentRevisor } from "store/actions";
import { MInput } from "components/forms";
import { withRouter } from "react-router-dom";

class ReviewCurrentLAC extends Component {
  state = {
    loading: true,
    rndKey: 0,
    payload: [],
    currentPayload: [],
    revisorId: null,
  };
  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "cfuTD",
        Header: "CFU da svolgere",
        accessor: (row) => {
          return row.cfuTD !== undefined ? row.cfuTD : "";
        },
      },
      {
        id: "dateToApprove",
        Header: "Data Invio Documenti",
        accessor: (row) => {
          return row.dateToApprove ? dateHelper.toITDateTime(row.dateToApprove) : "";
        },
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href = ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_COMPANY_DETAIL + "/" + value;
        },
      },
    ],
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props.match.params;
    const revisor = getCurrentRevisor(context);

    const revisorId = revisor?.id;

    if (revisorId) {
      this.setState({ revisorId });

      this.loadRemote(revisorId);
    } else this.loadRemote();
  }

  componentDidUpdate(prevProps) {
    const { activityType } = this.props.match.params;
    const { revisorId } = this.state;

    if (prevProps.match.params.activityType !== activityType) {
      this.loadRemote(revisorId);
    }
  }

  loadRemote(revisorId) {
    this.setState({ loading: true });

    const { activityType } = this.props.match.params;

    const filter = {
      status: "toApprove",
      lessonType: "training",
      revisorIdCompany: revisorId,
      activityType,
    };

    revisionService
      .listAllLessonActivityCompany(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          currentPayload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            currentPayload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
          });
        }
      });
  }

  onSearch = (value) => {
    const { payload } = this.state;

    if (value === "" || value.length === 0) {
      this.setState({ currentPayload: payload });
      return;
    }
    const filteredPayload = payload.filter((item) => item.courseCode.toLowerCase().includes(value.toLowerCase()));

    this.setState({
      currentPayload: filteredPayload,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });
  };

  render() {
    const searchField = {
      id: "searchRevision",
      name: "searchRevision",
      label: "cerca per classe di concorso o regione",
      type: "text",
      className: "form-control",
      onKeyUp: (elm, value) => {
        this.onSearch(value);
      },
    };

    const { loading } = this.state;
    const { activityType } = this.props.match.params;

    return (
      <>
        <Row>
          <Col>
            <Title subtitle={activityType === LESSON_ACTIVITY_TYPES.ABILITAZIONI ? "Percorsi Abilitanti" : "TFA XI ciclo"}>
              Tirocinio Diretto - Approvazione documenti <br />
            </Title>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="text-md-end">
            <MInput {...searchField} className="my-2" />
          </Col>
        </Row>
        <hr />
        <section className="my-5">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <>
              <Container>
                <MTable key={this.state.rndKey} tableData={this.state.currentPayload} tableConfig={this.tableConfig} />
              </Container>
            </>
          )}

          {this.state.currentPayload.length === 0 && (
            <BoxInfo key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare.</div>
            </BoxInfo>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewCurrentLAC);
